import { render, staticRenderFns } from "./IdNumberPdf.vue?vue&type=template&id=179d41ec&"
import script from "./IdNumberPdf.vue?vue&type=script&lang=js&"
export * from "./IdNumberPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports